module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "md4": ""
    }
  }, [_c('v-card', [_c('v-list', _vm._l((_vm.headers), function(header) {
    return _c('v-list-item', {
      key: header,
      attrs: {
        "href": _vm.getEditLink(header)
      }
    }, [_c('v-list-item-content', [(header === _vm.$route.params.level1) ? _c('v-list-item-title', [_c('b', [_vm._v(_vm._s(_vm._f("capitalize")(header)))])]) : _c('v-list-item-title', [_vm._v(_vm._s(_vm._f("capitalize")(header)))])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md8": ""
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-height": "20px"
    }
  }, [_c('isrs-i18n-dialog', _vm._b({
    attrs: {
      "is-multiline": _vm.$route.params.level1 === 'text'
    }
  }, 'isrs-i18n-dialog', {
    languages: _vm.languages,
    getText: _vm.getText,
    getDefault: _vm.getDefault,
    onSave: _vm.onSave,
    texts: _vm.texts
  }, false))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-7928949a"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsMailTextsDialog.vue
// module id = 945
// module chunks = 1